(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const checkoutButton = document.querySelector("#checkout"); // Select checkout button
    const cartFooter = document.createElement("div"); // Create the sticky footer
    cartFooter.classList.add("cart-footer");

    // Clone elements
    const totals = document.querySelector(".totals").cloneNode(true);
    const footerCheckoutButton = checkoutButton.cloneNode(true);
    footerCheckoutButton.id = "checkout-footer"; // Unique ID for the cloned button
    const dynamicCheckoutButtons = document.querySelector(".cart__dynamic-checkout-buttons").cloneNode(true);

    // Append cloned elements to the sticky footer
    cartFooter.appendChild(totals);
    cartFooter.appendChild(footerCheckoutButton);
    cartFooter.appendChild(dynamicCheckoutButtons);
    document.body.appendChild(cartFooter);

    function checkButtonVisibility() {
        if (!checkoutButton) return;

        const rect = checkoutButton.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

        if (isVisible) {
            cartFooter.style.display = "none"; // Hide sticky footer if button is visible
        } else {
            cartFooter.style.display = "flex"; // Show sticky footer if button is off-screen
        }
    }

    // Check visibility on page load and while scrolling
    checkButtonVisibility();
    window.addEventListener("scroll", checkButtonVisibility);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saphir-mega-menu"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================================
     Saphir Mega Menu — SaphirSolution
     - Hover-Modus wird per CSS gesteuert, JS ergänzt Klick, Tastatur und Mobil
     - Unterstützt den Shopify Theme Editor (Block-Auswahl hält das Panel offen)
     ========================================================================== */

  (function () {
    'use strict';

    var INSTANCES = [];

    function SaphirMegaMenu(root) {
      this.root = root;
      this.trigger = root.dataset.trigger || 'hover';
      this.mobileMode = root.dataset.mobile || 'accordion';
      this.breakpoint = parseInt(root.dataset.breakpoint, 10) || 990;
      this.items = Array.prototype.slice.call(root.querySelectorAll('[data-saphir-item]'));
      this.openItem = null;
      this.isMobile = false;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.syncViewport = this.syncViewport.bind(this);

      this.init();
    }

    SaphirMegaMenu.prototype.init = function () {
      var self = this;

      this.items.forEach(function (item) {
        var panel = item.querySelector('[data-saphir-panel]');
        var trigger = item.querySelector('[data-saphir-trigger]');
        var grid = panel ? panel.querySelector('.saphir-mega__grid') : null;
        var hasPanel = !!(grid && grid.children.length > 0);

        item.dataset.hasPanel = hasPanel ? 'true' : 'false';

        if (!trigger) return;

        if (hasPanel) {
          trigger.setAttribute('aria-haspopup', 'true');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          trigger.removeAttribute('aria-haspopup');
          trigger.removeAttribute('aria-expanded');
        }

        trigger.addEventListener('click', function (event) {
          if (item.dataset.hasPanel !== 'true') return;

          var useClick = self.isMobile || self.trigger === 'click' || self.isTouch();
          if (!useClick) return;

          // Erster Klick öffnet, zweiter Klick folgt dem Link (falls vorhanden)
          if (!item.classList.contains('is-open')) {
            event.preventDefault();
            self.open(item);
          } else if (trigger.tagName !== 'A') {
            event.preventDefault();
            self.close(item);
          }
        });

        // Hover schließt ein per Klick geöffnetes Panel wieder sauber
        item.addEventListener('mouseleave', function () {
          if (!self.isMobile && self.trigger === 'hover') self.close(item);
        });
      });

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.syncViewport, { passive: true });

      this.syncViewport();
    };

    SaphirMegaMenu.prototype.isTouch = function () {
      return window.matchMedia('(hover: none)').matches;
    };

    SaphirMegaMenu.prototype.syncViewport = function () {
      var mobile = window.innerWidth <= this.breakpoint;
      if (mobile === this.isMobile) return;
      this.isMobile = mobile;
      this.root.classList.toggle('is-mobile', mobile);
      this.closeAll();
    };

    SaphirMegaMenu.prototype.open = function (item) {
      if (!item || item.dataset.hasPanel !== 'true') return;
      if (this.openItem && this.openItem !== item) this.close(this.openItem);

      item.classList.add('is-open');
      var trigger = item.querySelector('[data-saphir-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      this.openItem = item;
    };

    SaphirMegaMenu.prototype.close = function (item) {
      if (!item) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-saphir-trigger]');
      if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
      if (this.openItem === item) this.openItem = null;
    };

    SaphirMegaMenu.prototype.closeAll = function () {
      var self = this;
      this.items.forEach(function (item) {
        self.close(item);
      });
    };

    SaphirMegaMenu.prototype.onDocumentClick = function (event) {
      if (!this.openItem) return;
      if (this.root.contains(event.target)) return;
      this.closeAll();
    };

    SaphirMegaMenu.prototype.onKeydown = function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (!this.openItem) return;
      var trigger = this.openItem.querySelector('[data-saphir-trigger]');
      this.closeAll();
      if (trigger) trigger.focus();
    };

    SaphirMegaMenu.prototype.destroy = function () {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.syncViewport);
    };

    function mount(scope) {
      var context = scope || document;
      var roots = Array.prototype.slice.call(context.querySelectorAll('[data-saphir-mega]'));
      roots.forEach(function (root) {
        if (root.saphirMegaMenu) return;
        root.saphirMegaMenu = new SaphirMegaMenu(root);
        INSTANCES.push(root.saphirMegaMenu);
      });
    }

    function unmount(scope) {
      INSTANCES = INSTANCES.filter(function (instance) {
        if (scope && !scope.contains(instance.root)) return true;
        instance.destroy();
        return false;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        mount();
      });
    } else {
      mount();
    }

    /* ---------------------------------------------------- Shopify Theme Editor */

    document.addEventListener('shopify:section:load', function (event) {
      mount(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      unmount(event.target);
    });

    function itemFor(target) {
      if (!target || !target.closest) return null;
      return target.closest('[data-saphir-item]');
    }

    function instanceFor(node) {
      var root = node && node.closest ? node.closest('[data-saphir-mega]') : null;
      return root ? root.saphirMegaMenu : null;
    }

    ['shopify:block:select', 'shopify:section:select'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        var item = itemFor(event.target);
        var instance = instanceFor(event.target);
        if (!instance || !item) return;
        instance.open(item);
        item.scrollIntoView({ block: 'nearest' });
      });
    });

    ['shopify:block:deselect', 'shopify:section:deselect'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        var item = itemFor(event.target);
        var instance = instanceFor(event.target);
        if (!instance || !item) return;
        instance.close(item);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
